import { useMutation } from "@tanstack/react-query";
import PickupService from "../app/data/pickup/pickupService";

const pickupService = PickupService.getInstance();

export const useUploadBol = (pickupId: string) => {
  return useMutation({
    mutationFn: (file: File) => {
      const formData = new FormData();
      formData.append("file", file);

      return pickupService.afterUploadPickupBOL(pickupId, formData);
    },
  });
};